const parse = (obj: any) => JSON.parse(JSON.stringify(obj));
export default parse;
